import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, onMounted, ref } from 'vue';
import { channelKey } from '@/keys';


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieDeclaration',
  props: {
  cookiebotSerial: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const channel = inject(channelKey);
const containerEl = ref<HTMLElement | null>(null);

// eslint-disable-next-line no-undef


function getLanguage() {
  return channel?.value?.locale?.split('-')[0] || 'en';
}

onMounted(() => {
  const script = document.createElement('script');
  script.id = 'CookieDeclaration';
  script.src = `https://consent.cookiebot.com/${props.cookiebotSerial}/cd.js`;
  script.type = 'text/javascript';
  script.async = true;
  script.dataset.culture = getLanguage();
  containerEl.value?.appendChild(script);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerEl",
    ref: containerEl
  }, null, 512))
}
}

})